'use client'

import { useState, type CSSProperties, type DragEvent, type ReactNode } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

interface DropzoneProps {
  children?: ReactNode
  onDrop?: (files: File[]) => void
  // Raw-event variant for callers that need `dataTransfer.items` (directory
  // entries, etc.). When provided, `onDrop` is ignored.
  onDropEvent?: (event: DragEvent<HTMLElement>) => void
  disabled?: boolean
  accent?: AccentVar
  className?: string
  style?: CSSProperties
}

export function Dropzone({ children, onDrop, onDropEvent, disabled, className, style }: DropzoneProps) {
  const [over, setOver] = useState(false)
  return (
    <section
      className={cx('st-dropzone', over && 'dragover', disabled && 'disabled', className)}
      style={disabled ? { opacity: 0.5, pointerEvents: 'none', ...style } : style}
      onDragEnter={(e) => {
        e.preventDefault()
        if (!disabled) setOver(true)
      }}
      onDragOver={(e) => {
        e.preventDefault()
        if (!disabled) setOver(true)
      }}
      onDragLeave={(e) => {
        e.preventDefault()
        setOver(false)
      }}
      onDrop={(e) => {
        e.preventDefault()
        setOver(false)
        if (disabled) return
        if (onDropEvent) {
          onDropEvent(e)
          return
        }
        onDrop?.([...(e.dataTransfer?.files || [])])
      }}>
      {children}
    </section>
  )
}
